import { ReactComponent as Check } from "assets/icons/check-green-square.svg";
import { ReactComponent as Close } from "assets/icons/close-square.svg";

const Logo = ({ data }) => {
  const renderReceiptIcon = () => {
    return data.get("status") === "SUCCESS" ? (
      <Check className="mx-auto" />
    ) : (
      <Close className="mx-auto" />
    );
  };
  const renderIconStyle = () => {
    return data.get("status") === "SUCCESS" ? "bg-success--8" : "bg-error--8";
  };

  return (
    <div className={`rounded-xl w-16 p-2.5  mx-auto  ${renderIconStyle()}`}>
      {renderReceiptIcon()}
    </div>
  );
};
export default Logo;
